/**
 * Budget Stat Badge Component
 *
 * Displays a single stat with icon, label, and currency value
 * Used in budget phase cards to show "Orçamento Executado" and "Último Orçamento Aprovado"
 */

import { ReactNode } from "react";

interface BudgetStatBadgeProps {
  /** Icon component to display */
  icon: ReactNode;
  /** Label text (e.g., "Orçamento Executado") */
  label: string;
  /** Currency value to display */
  value: number;
}

export function BudgetStatBadge({
  icon,
  label,
  value,
}: BudgetStatBadgeProps) {
  // Format currency to Brazilian Real
  const formatCurrency = (val: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(val);
  };

  return (
    <div className="flex gap-2 items-center">
      {/* Icon with circular background */}
      <div className="relative w-8 h-8 bg-[#0C1427] rounded-full flex items-center justify-center flex-shrink-0">
        <div className="text-white">{icon}</div>
      </div>

      {/* Label and value */}
      <div className="flex flex-col gap-0.5">
        <p className="text-[10px] font-normal text-[#E7E7E7]">{label}</p>
        <p className="text-sm font-bold text-white whitespace-nowrap">
          {formatCurrency(value)}
        </p>
      </div>
    </div>
  );
}
